import React, { PropTypes } from 'react';
import ModalDialog from 'common/components/modal/modal_dialog';

const ParticipantMsgPreview = ({ showing, onClose, fullName, message }) => {
  return (
    <ModalDialog modalOpen={showing} closeAction={onClose} modalHeader="Preview"
      dialogClasses="msg-preview-modal" onPrimary={onClose} primaryLabel="Done">
      <p>Hey there,</p>
      <br />
      <p>
        { fullName } needs your help. They invited you to provide some design feedback.<br/>
      </p>
      <br />
      <p>{ fullName } included the following note with the invitation:</p>
      <p>{ message || 'YOUR PERSONAL MESSAGE WILL SHOW HERE' }</p>
      <br />
      <p>
        To accept the invitation, please click the following link (you'll also need the password we
        included below):
      </p>
      <p>
        <a>https://****.pickfavorite.com/presentation-participate/56143/98531/</a>
      </p>
      <br />
      <p>Password: ******</p>
      <br />
      <p>See you soon!</p>
    </ModalDialog>
  );
}

ParticipantMsgPreview.propTypes = {
  showing: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  fullName: PropTypes.string.isRequired,
  message: PropTypes.string,
};

export default ParticipantMsgPreview;



// WEBPACK FOOTER //
// ./presentations/components/participant_msg_preview.jsx